import React, {useState} from 'react';
import { Segmented, Table, Row, Col, Typography, Divider } from 'antd';
import PnL from '../../../Components/PnL';
import {stringMixin} from "../../../utils/strings";
import NivoScatterChart from "../../../charts/nivo/NivoScatterChart";
import {prepareBestWorstData} from "../utils";


const Risk = ({ items, itemColors }) => {
  const [window, setWindow] = useState('252');
  const [period, setPeriod] = useState('1 Year');
  const handleYearChange = (value) => {
    setPeriod(value);

    // Update window based on the selected period
    switch (value) {
      case '1 Year':
        setWindow('252');
        break;
      case '3 Year':
        setWindow('756');
        break;
      case '5 Year':
        setWindow('1260');
        break;
      default:
        setWindow('252'); // Default in case of an unexpected value
    }
  };
  const columns = [
    {
      title: 'Name',
      dataIndex: 'label',
      key: 'label',
      className: 'header'

    },
    {
      title: 'Best in Window',
      dataIndex: 'best',
      key: 'best',
      render: (value) => PnL({value}),

    },
    {
      title: 'Worst in Window',
      dataIndex: 'worst',
      key: 'worst',
      render: (value) => PnL({value}),
    },
    {
      title: 'Back to Even',
      dataIndex: 'backToEven',
      key: 'backToEven',
      render: (value) => stringMixin.pct(value),

    },
    {
      title: 'Beta',
      dataIndex: 'beta',
      key: 'beta',
      render: (value) => stringMixin.pct(value),
    },
    {
      title: 'Sharpe Ratio',
      dataIndex: 'sharpe',
      key: 'sharpe',
      render: (value) => value.toFixed(2),

    },
  ];
  const data = prepareBestWorstData(items, window);

  const nivoScatterData = data.map((d)=>{
    return {
      id: d.label,
      data: [
        {x: d.beta, y: d.sharpe}
      ]
    }
  });
  console.log(items, itemColors);
  const colors = {};
  items.forEach(x=>{
    colors[x.label] = itemColors[x.id];
  });
  console.log(colors);



  return (
      <>
        <Segmented
          options={['1 Year', '3 Year', '5 Year']}
          value={period}
          onChange={handleYearChange}
        />
        <Table columns={columns} dataSource={data} pagination={false} />
        <Divider/>
        <Typography.Title level={4}>Return v Risk Premium</Typography.Title>
        <Typography.Text>Shows visual of the risk incurred in the portfolio (beta) relative to premium on return gained (sharpe)</Typography.Text>
        <div style={{height: '500px'}}>
              <NivoScatterChart
                  height={500}
                data={nivoScatterData}
                keys={data.map(d=>d.label)}
                customColors={colors}
                axisLeftLegend={'Sharpe Ratio'}
                axisBottomLegend={'Beta'}
                dotSize={40}
                showLabels={true}
              />
        </div>
      </>
  )
};

export default Risk;
